// SPDX-License-Identifier: AGPL-3.0-or-later
import {Permissions} from '@app/vendor/constants/ChannelConstants';
import {useLingui} from '@lingui/react/macro';
import {useMemo} from 'react';

interface SimpleCommand {
	type: 'simple';
	name: string;
	content: string;
	description: string;
}
interface ActionCommand {
	type: 'action';
	name: string;
	description: string;
	permission?: bigint;
	requiresGuild?: boolean;
}
export type Command = SimpleCommand | ActionCommand;
export function useCommands(): Array<Command> {
	const {t} = useLingui();
	return useMemo(
		(): Array<Command> => [
			{type: 'simple', name: '/shrug', content: '¯\\_(ツ)_/¯', description: t`Appends ¯\\_(ツ)_/¯ to your message.`},
			{
				type: 'simple',
				name: '/tableflip',
				content: '(╯°□°)╯︵ ┻━┻',
				description: t`Appends (╯°□°)╯︵ ┻━┻ to your message.`,
			},
			{
				type: 'simple',
				name: '/unflip',
				content: '┬─┬ ノ( ゜-゜ノ)',
				description: t`Appends ┬─┬ ノ( ゜-゜ノ) to your message.`,
			},
			{type: 'action', name: '/me', description: t`Send an action message (wraps in italics).`},
			{type: 'action', name: '/spoiler', description: t`Send a spoiler message (wraps in spoiler tags).`},
			{
				type: 'action',
				name: '/tts',
				description: t`Send a text-to-speech message.`,
				permission: Permissions.SEND_TTS_MESSAGES,
			},
			{
				type: 'action',
				name: '/nick',
				description: t`Change your nickname in this community.`,
				permission: Permissions.CHANGE_NICKNAME,
				requiresGuild: true,
			},
			{
				type: 'action',
				name: '/kick',
				description: t`Kick a member from this community.`,
				permission: Permissions.KICK_MEMBERS,
				requiresGuild: true,
			},
			{
				type: 'action',
				name: '/ban',
				description: t`Ban a member from this community.`,
				permission: Permissions.BAN_MEMBERS,
				requiresGuild: true,
			},
			{type: 'action', name: '/msg', description: t`Send a direct message to a user.`},
			{type: 'action', name: '/saved', description: t`Send a saved media item.`},
			{type: 'action', name: '/sticker', description: t`Send a sticker.`},
			{type: 'action', name: '/gif', description: t`Search for and send a GIF.`},
		],
		[t],
	);
}
